<!-- <IFA-header></IFA-header> -->
<div
  _ngcontent-ign-c19=""
  id="Optimum-wealth-home"
  class="Optimum-official-offerings">
  <div class="insurance-wrapper padding-top30 nps-wrapper">
    <section class="section-insur" id="about-insurance">
      <div class="container">
        <div class="insur-row">
          <div class="insur-left-block freeconsultantbox mobilemt-20">
            <div class="content-panel">
              <div class="row d-flex">
                <div class="col-12">
                  <div class="sb-tag sb-offerings mb-12">talk to us</div>
                  <h2 class="wealth-section-title mb-6">Let's Connect</h2>
                  <p class="wealth-section-description">
                    Simply reach us on our contact info Or fill the form & we
                    will call you.
                  </p>
                </div>
              </div>
              <div class="col-12 col-xs-12 col-md-12 col-sm-12 nopadding">
                <div class="info-wrap w-100 mt-20">
                  <div class="dbox w-100 d-flex align-items-center">
                    <div
                      class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-phone"></span>
                    </div>
                    <div class="text pl-3 MobileText">
                      <p>
                        <a href="tel://9876789077">{{ footercontacttext }}</a>
                      </p>
                    </div>
                  </div>
                  <div class="dbox w-100 d-flex align-items-center">
                    <div
                      class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-paper-plane"></span>
                    </div>
                    <div class="text pl-3">
                      <p>
                        <a href="mailto:info@yoursite.com">{{ mailtext }}</a>
                      </p>
                    </div>
                  </div>

                  <div class="dbox w-100 d-flex align-items-center">
                    <div
                      class="icon d-flex align-items-center justify-content-center">
                      <span class="fa fa-map-marker"></span>
                    </div>
                    <div class="text pl-3">
                      <p>
                        <a>{{ footeraddresstext }}</a>
                      </p>
                    </div>
                  </div>

                  <!-- <div class="dbox w-100 d-flex align-items-center">
                  <div class="icon d-flex align-items-center justify-content-center">
                  <span class="fa fa-map"></span>
                  </div>
                  <div class="text pl-3">
                  <p><a href="#">View on Google Maps</a></p>
                  </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <div
            class="insur-right-block freeconsultantbox"
            style="margin-top: 80px !important">
            <form
              [formGroup]="LetsTalkForm"
              (ngSubmit)="onsubmitLetsTalkForm()">
              <div
                class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-xs-12 mobilemt-20">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        formControlName="customer_name"
                        class="form-control"
                        id="customer_name"
                        maxlength="30"
                        placeholder="Full Name"
                        name="customer-name"
                        type="text"
                        required />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                            <div class="call-plan-form-group call-plan-form-group-name">

                              <input class="form-control" id="customer_name" placeholder="last name"
                                maxlength="30" name="customer-name" required="" type="text">
                              <label for="customer-name"></label>
                              <span class="d-none customer-name-error" style="color: red">
                                Please enter your name
                              </span>
                            </div>
                          </div> -->
                </div>
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        formControlName="Mobile_No"
                        id="Mobile_No"
                        maxlength="30"
                        placeholder="Mobile"
                        name="Mobile_No"
                        required
                        type="number" />
                      <label for="Mobile_No"></label>
                      <div *ngIf="f.Mobile_No.touched && f.Mobile_No.invalid">
                        <span
                          *ngIf="f.Mobile_No.errors.required"
                          class="d-none Mobile_No-error"
                          style="color: red">
                          Mobile Number is required.
                        </span>
                        <span
                          *ngIf="f.Mobile_No.errors.pattern"
                          class="d-none Mobile_No-error"
                          style="color: red">
                          Please, Enter 10 digit Mobile Number.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        formControlName="customer_Email"
                        id="customer_Email"
                        placeholder="Email"
                        maxlength="70"
                        name="customer_Email"
                        required
                        type="text" />
                      <label for="customer_Email"></label>
                      <span
                        class="d-none customer_Email-error"
                        style="color: red">
                        Please enter your email id
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <!-- <select class="form-control">
                        <option>State</option>
                      </select> -->
                      <input
                        class="form-control"
                        formControlName="Statein"
                        id="Statein"
                        placeholder="State"
                        maxlength="30"
                        name="Statein"
                        required
                        type="text" />
                      <label for="Statein"></label>
                      <span class="d-none Statein-error" style="color: red">
                        Please enter state
                      </span>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        formControlName="city_name"
                        id="city_name"
                        maxlength="30"
                        placeholder="City"
                        name="city_name"
                        required
                        type="text" />
                      <label for="city_name"></label>
                      <span class="d-none city_name-error" style="color: red">
                        Please enter city name
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        formControlName="customer_Meassage"
                        id="customer_Meassage"
                        maxlength="30"
                        placeholder="Message"
                        name="customer_Meassage"
                        required
                        type="text" />
                      <label for="customer_Meassage"></label>
                      <span
                        class="d-none customer_Meassage-error"
                        style="color: red">
                        Please enter some Message
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="call-plan-form-group">
                      <label class="form-label">Preferred time to talk:</label>
                    </div>
                    <div
                      class="btn-group btn-group-toggle select-call-time select-call-time-js"
                      data-toggle="buttons">
                      <label class="btn btn-outline-sb-green option-1 active">
                        <input
                          data-max="12"
                          data-min="8"
                          id="option1"
                          name="talk_schedule1"
                          type="radio"
                          value="morning"
                          formControlName="talk_schedule1"
                          (click)="Scheduletimecall($event)" />

                        10 - 12
                      </label>
                      <label class="btn btn-outline-sb-green option-2">
                        <input
                          data-max="16"
                          data-min="12"
                          id="option2"
                          name="talk_schedule1"
                          type="radio"
                          value="afternoon"
                          formControlName="talk_schedule1"
                          (click)="Scheduletimecall($event)" />

                        12 - 2
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="talk_schedule1"
                          type="radio"
                          value="evening"
                          formControlName="talk_schedule1"
                          (click)="Scheduletimecall($event)" />

                        2 - 4
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="talk_schedule1"
                          type="radio"
                          value="evening"
                          formControlName="talk_schedule1"
                          (click)="Scheduletimecall($event)" />

                        4 - 6
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="talk_schedule1"
                          type="radio"
                          value="evening"
                          formControlName="talk_schedule1"
                          (click)="Scheduletimecall($event)" />

                        6 - 8
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="call-plan-form-group pb-3 text-center mt-30 mobilemt-0 mobilemb-20">
                      <div
                        class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                        data-action="schedule a call-Plan"
                        data-category="offering-Plan"
                        data-label="planning section">
                        <button type="submit">
                          <!-- [disabled]="!LetsTalkForm.valid"-->
                          Let's Talk
                        </button>
                      </div>
                      <a
                        href="mf/MobileMutualFund"
                        style="font-size: 10px"
                        target="_self"
                        class="anchorColor desktopHide">
                        Click here to know more about Mutual Funds first
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<IFA-footer></IFA-footer>
